<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="pensionsToDownload"
        :fields="fieldsExport"
        name="pensions.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs3>
          <v-radio-group
            :column="false"
            v-model="pensionStatusFilter">
            <v-radio
              color="primary"
              label="Pendientes"
              value="0"
            ></v-radio>
            <v-radio
              color="primary"
              label="Pagadas"
              value="1"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout v-if="pensionStatusFilter == 1" row wrap>
        <v-flex xs3>
          <date-picker
            :form="form"
            label="Fecha inicial"
            :v-errors="errors"
            :value.sync="form.start_date"
            name="start_date"
            v-validate="'required'"
          ></date-picker>
        </v-flex>
        <v-flex xs3>
          <date-picker
            :form="form"
            label="Fecha final"
            :v-errors="errors"
            :value.sync="form.end_date"
            name="end_date"
            v-validate="'required'"
          ></date-picker>
        </v-flex>
        <v-flex xs2>
          <v-btn
            @click="filerPensions()"
            :loading="loading_query_button"
            :disabled="loading_query_button"
            color="primary">Consultar</v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="pensionStatusFilter == 0" row wrap>
        <v-flex xs3>
          <v-select
            v-model="pengindFilter"
            :items="pengindFilterItems"
            label="Tipo"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout v-if="pensionStatusFilter == 0" row wrap>
        <v-flex xs12>
          <div>
            <v-toolbar flat color="white">
              <v-layout v-if="paymentSummary.length > 0" justify-space-between row wrap>
                <v-flex class="text-xs-center " xs4>
                  <v-chip class="title" label>
                    Facturas: {{ paymentSummary.length }}
                  </v-chip>
                  <v-chip class="title" label>
                    Total: ${{ formatNumber(totalPayment) }}
                  </v-chip>
                </v-flex>
                <v-flex xs2>
                  <v-btn
                    @click="pay()"
                    color="primary"
                    :disabled="loading_button !== 0"
                    :loading="loading_button !== 0">Pagar seleccionados</v-btn>
                </v-flex>
              </v-layout>
            </v-toolbar>
            <v-data-table
              :headers="headers"
              :items="pensionToShow"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  <v-checkbox
                    :disabled="isPending(props.item.rowid_docto) || isApproved(props.item.rowid_docto) || props.item.total < 0"
                    color="primary"
                    v-model="reciptsToPay[props.item.rowid_docto]"
                    class="center"
                    hide-details
                  ></v-checkbox>
                </td>
                <td class="text-xs-center">{{ props.item.type }}</td>
                <td class="text-xs-center no-wrap">{{ props.item.receipt }}</td>
                <td class="text-xs-center">{{ props.item.notas }}</td>
                <td class="text-xs-center no-wrap">{{ props.item.fecha_fact }}</td>
                <td class="text-xs-center no-wrap"  :class="props.item.dias_vencida > 0 ? 'red--text' :''">
                  <v-tooltip v-show="parseInt(props.item.dias_vencida) > 0" top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-if="parseInt(props.item.dias_vencida) > 0" small color="red darken-2" v-on="on">warning</v-icon>
                    </template>
                    <span>{{ props.item.dias_vencida }} días de vencida</span>
                  </v-tooltip>
                  {{ props.item.fecha_vence }}
                </td>
                <td class="text-xs-center">{{ props.item.student }}</td>
                <td class="text-xs-center">{{ props.item.total_show }}</td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="isPending(props.item.rowid_docto)"
                    @click="validatePayment(pendingPlatform[props.item.rowid_docto])"
                    :disabled="loading_val_button == props.item.rowid_docto"
                    :loading="loading_val_button == props.item.rowid_docto"
                    color="secondary">Validar pago</v-btn>
                  <v-btn
                    v-if="!isApproved(props.item.rowid_docto)"
                    @click="pay(props.item.rowid_docto)"
                    :disabled="paymentSummary.length > 0 || loading_button == props.item.rowid_docto || isPending(props.item.rowid_docto) || props.item.total < 0"
                    :loading="loading_button === props.item.rowid_docto"
                    color="primary">Pagar</v-btn>
                  <v-btn
                    v-if="isFailed(props.item.rowid_docto)"
                    @click="paymentProof(props.item.rowid_docto, props.item.student + ' ' + props.item.notas)"
                    color="error">Pago fallido</v-btn>
                  <v-btn
                    v-if="isApproved(props.item.rowid_docto)"
                    @click="paymentProof(props.item.rowid_docto, props.item.student + ' ' + props.item.notas)"
                    color="success">Ver comprobante</v-btn>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-if="pensionStatusFilter == 1" row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers_filter"
            :items="filerPensionsToShow"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.type }}</td>
              <td class="text-xs-center">{{ props.item.receipt }}</td>
              <td class="text-xs-center">{{ props.item.notas }}</td>
              <td class="text-xs-center">{{ props.item.fecha_fact }}</td>
              <td class="text-xs-center">{{ props.item.fecha_cancelado }}</td>
              <td class="text-xs-center">{{ props.item.student }}</td>
              <td class="text-xs-center">{{ props.item.total_show }}</td>
              <td class="text-xs-center">
                <v-btn
                  v-if="!!props.item.fecha_cancelado"
                  @click="downloadPaymentProof(props.item.rowid_docto)"
                  color="primary">Descargar</v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog
      v-model="payment_dialog"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
        >
          {{ $t('payments.payment_text_title') }}
        </v-card-title>

        <v-card-text v-html="$t('payments.payment_text')">
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog
        v-model="payment_detail_dialog"
        width="350"
        persistent
      >
      <payment-proof
        :payment="payment_to_show"
        :payment_detail="payment_detail"
      >
      </payment-proof>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="payment_detail_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Dialogo alerta pago vencido: -->
    <v-dialog v-model="overdue_payment_dialog" persistent max-width="390">
      <v-card>
        <v-card-title class="headline red--text">{{ overdue_bills }} {{ overdue_bills > 1 ? 'Facturas vencidas' : 'Factura vencida' }}</v-card-title>
        <v-card-text>Usted esta realizando el pago de <b>{{ overdue_bills }} {{ overdue_bills > 1 ? 'facturas vencidas' : 'factura vencida' }}</b>, tenga presente que los intereses por mora se les generarán en una factura adicional.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" flat @click="overdue_is_accepted = false; overdue_payment_dialog = false">Cancelar</v-btn>
          <v-btn color="green darken-1" flat @click="overdue_is_accepted = true; overdue_payment_dialog = false; pay(overdue_rowid_docto)">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import paymentProof from './../payment/proof'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'pensions-show-view',
    components: {
      'payment-proof': paymentProof,
      'download-excel': JsonExcel,
    },
    data() {
      return {
        pensions: [],
        students: {},
        pendingPlatform: [],
        reciptsToPay: {},
        payment_dialog: false,
        loading_button: 0,
        loading_val_button: 0,
        payment_detail_dialog: false,
        payment_to_show: {},
        payment_detail: '',
        pensionStatusFilter: '0',
        loading_query_button: false,
        filteredPensions: [],
        overdue_bills: 0,
        overdue_payment_dialog: false,
        overdue_is_accepted: false,
        overdue_rowid_docto: null,
        form: {
          start_date: '',
          end_date: '',
        },
        pengindFilter: 'ALL',
        pengindFilterItems: [
          { value: 'ALL', text: 'Todos' },
          { value: 'DEP', text: 'Pensiones' },
          { value: 'DEI', text: 'Intereses' },
          { value: 'DEM', text: 'Matrículas' },
          { value: 'FEM', text: 'Matrículas FE.' },
          { value: 'FEP', text: 'Matrículas FE.' },
        ],
        headers: [
          { text: 'Pagar', value: 'pay', align: 'center', sortable: false, },
          { text: 'Tipo', value: 'type', align: 'center', sortable: false },
          { text: 'Factura', value: 'consec_docto', align: 'center', sortable: false },
          { text: 'Descripción', value: 'notas', align: 'center', sortable: false, },
          { text: 'Fecha', value: 'fecha_fact', align: 'center', },
          { text: 'Vencimiento', value: 'fecha_vence', align: 'center', },
          { text: 'Estudiante', value: 'first_name', align: 'center', },
          { text: 'Valor', value: 'total_show', align: 'center', },
          { text: 'Acciones', value: 'acciones', align: 'center', },
        ],
        headers_filter: [
          { text: 'Tipo', value: 'type', align: 'center', sortable: false },
          { text: 'Factura', value: 'consec_docto', align: 'center', sortable: false },
          { text: 'Descripción', value: 'notas', align: 'center', sortable: false },
          { text: 'Fecha factura', value: 'fecha_fact', align: 'center', },
          { text: 'Fecha pagado', value: 'fecha_cancelado', align: 'center', },
          { text: 'Estudiante', value: 'first_name', align: 'center', },
          { text: 'Valor', value: 'total_show', align: 'center', },
          { text: 'Acciones', value: 'acciones', align: 'center', },
        ],
        fieldsExport1: {
          'Tipo': 'type',
          'Factura': 'consec_docto',
          'Notas': 'notas',
          'Fecha factura': 'fecha_fact',
          'Fecha vencimiento': 'fecha_vence',
          'Estudiante': 'student',
          'Total a pagar': 'total_show',
          'Estado': 'estado',
        },
        fieldsExport2: {
          'Tipo': 'type',
          'Factura': 'consec_docto',
          'Notas': 'notas',
          'Fecha factura': 'fecha_fact',
          'Fecha pagado': 'fecha_cancelado',
          'Estudiante': 'student',
          'Total pagado': 'total_show',
          'Estado': 'estado',
        },
      }
    },
    created () {
      this.getPending();
    },
    computed: {
      pensionToShow() {
        const filter = this.pengindFilter
        return this.pensions.map(pension => {
          let type = ''
          if (pension.tipo_docto == 'DEP') type = 'Pensión'
          else if (pension.tipo_docto == 'FEP') type = 'Pensión'
          else if (pension.tipo_docto == 'DEI') type = 'Intereses'
          else if (pension.tipo_docto == 'DEM') type = 'Matrículas'
          else if (pension.tipo_docto == 'FEM') type = 'Matrículas'
          else if (pension.tipo_docto == 'FES') type = 'Servicios'
          else if (pension.tipo_docto == 'NDP') type = 'Nota Débito Pensiones'
          else if (pension.tipo_docto == 'NDM') type = 'Nota Débito Matrícula'
          
          return {
            type,
            receipt: `001-${pension.tipo_docto}-${pension.consec_docto}`,
            notas: pension.notas.split(',')[0] || pension.notas,
            fecha_fact: pension.fecha_fact,
            fecha_vence: pension.fecha_vence,
            dias_vencida: pension.dias_vencida,
            student: this.students[`${pension.siesa_sucursal}${pension.nit}`] && this.students[`${pension.siesa_sucursal}${pension.nit}`].first_name,
            total_show: pension.total_show,
            total: parseFloat(pension.total),
            rowid_docto: pension.rowid_docto,
            tipo_docto: pension.tipo_docto
          }
        })
        .filter(pension => pension.student)
        .filter(pension => filter === 'ALL' ? true : pension.tipo_docto === filter)
      },
      filerPensionsToShow() {
        return this.filteredPensions.map(pension => {
          let type = ''
          if (pension.tipo_docto == 'DEP') type = 'Pensión'
          else if (pension.tipo_docto == 'FEP') type = 'Pensión'
          else if (pension.tipo_docto == 'DEI') type = 'Intereses'
          else if (pension.tipo_docto == 'DEM') type = 'Matrículas'
          else if (pension.tipo_docto == 'FEM') type = 'Matrículas'
          else if (pension.tipo_docto == 'FES') type = 'Servicios'
          else if (pension.tipo_docto == 'NDP') type = 'Nota Débito Pensiones'
          else if (pension.tipo_docto == 'NDM') type = 'Nota Débito Matrícula'
          return {
            type,
            receipt: `001-${pension.tipo_docto}-${pension.consec_docto}`,
            notas: pension.notas.split(',')[0] || pension.notas,
            fecha_fact: pension.fecha_fact,
            fecha_cancelado: pension.fecha_cancelado,
            student: this.students[`${pension.siesa_sucursal}${pension.nit}`] && this.students[`${pension.siesa_sucursal}${pension.nit}`].first_name,
            total_show: pension.total_show,
            total: parseFloat(pension.total),
            rowid_docto: pension.rowid_docto,
          }
        })
        .filter(pension => pension.student)
      },
      paymentSummary() {
        return Object
          .keys(this.reciptsToPay)
          .map(pension => this.reciptsToPay[pension] && pension)
          .filter(_ => !!_)
          .map(pension =>
            this.pensions
            .filter(fp => fp.rowid_docto == pension)
            .map(({ rowid_docto, consec_docto, tipo_docto, total, siesa_sucursal, notas, dias_vencida, nit }) =>
                 ({ rowid_docto, consec_docto, tipo_docto, total, siesa_sucursal, notas, dias_vencida, nit }))[0]
          )
      },
      totalPayment() {
        return this.paymentSummary
          .reduce((acc, receipt) => acc + parseInt(receipt.total, 10), 0)
      },
      overdue_bills() {
        return this.paymentSummary
          .filter(x => x.dias_vencida > 0 ).length
      },
      fieldsExport() {
        return this.pensionStatusFilter == 0 ? {...this.fieldsExport1} : {...this.fieldsExport2}
      },
      pensionsToDownload() {
        let pensions
        if (this.pensionStatusFilter == 0) {
          pensions = this.pensions.map(pension => {
            let type = ''
            if (pension.tipo_docto == 'DEP') type = 'Pensión'
            else if (pension.tipo_docto == 'FEP') type = 'Pensión'
            else if (pension.tipo_docto == 'DEI') type = 'Intereses'
            else if (pension.tipo_docto == 'DEM') type = 'Matrículas'
            else if (pension.tipo_docto == 'FEM') type = 'Matrículas'
            else if (pension.tipo_docto == 'FES') type = 'Servicios'
            else if (pension.tipo_docto == 'NDP') type = 'Nota Débito Pensiones'
            else if (pension.tipo_docto == 'NDM') type = 'Nota Débito Matrícula'
            return {
              type,
              consec_docto: `001-${pension.tipo_docto}-${pension.consec_docto}`,
              notas: pension.notas.split(',')[0],
              fecha_fact: pension.fecha_fact,
              fecha_vence: pension.fecha_vence,
              student: this.students[`${pension.siesa_sucursal}${pension.nit}`] && this.students[`${pension.siesa_sucursal}${pension.nit}`].first_name,
              total_show: pension.total_show,
              estado: 'PENDIENTE'
            }
          })
        } else {
          pensions = this.filteredPensions.map(pension => {
            let type = ''
            if (pension.tipo_docto == 'DEP') type = 'Pensión'
            else if (pension.tipo_docto == 'FEP') type = 'Pensión'
            else if (pension.tipo_docto == 'DEI') type = 'Intereses'
            else if (pension.tipo_docto == 'DEM') type = 'Matrículas'
            else if (pension.tipo_docto == 'FEM') type = 'Matrículas'
            else if (pension.tipo_docto == 'FES') type = 'Servicios'
            else if (pension.tipo_docto == 'NDP') type = 'Nota Débito Pensiones'
            else if (pension.tipo_docto == 'NDM') type = 'Nota Débito Matrícula'
            return {
              type,
              consec_docto: `001-${pension.tipo_docto}-${pension.consec_docto}`,
              notas: pension.notas.split(',')[0],
              fecha_fact: pension.fecha_fact,
              fecha_cancelado: pension.fecha_cancelado,
              student: this.students[`${pension.siesa_sucursal}${pension.nit}`] && this.students[`${pension.siesa_sucursal}${pension.nit}`].first_name,
              total_show: pension.total_show,
              estado: 'PAGADO',
            }
          })
        }
        return pensions
      }
    },
    methods: {
      getPending() {
        axios.get('/api/pension/pending')
          .then(resp => {
            if (resp.status === 200) {
              const { students, pension, platform_pending, prev_date, curr_date } = resp.data
              this.pensions = pension
              this.students = this.converToObject(students, ['siesa_sucursal', 'siesa_tercero_id'])
              this.pendingPlatform = this.converToObject(platform_pending, ['rowid_docto'])
              this.form.start_date = prev_date;
              this.form.end_date = curr_date;
              this.filerPensions()
              this.validatePaymentParam()
            }
          })
          .catch(err => console.log(err))
      },
      converToObject(array, keys) {
        const init = {}
        return array.reduce((obj, item) => {
          let objKey = ''
          Object.entries(item).forEach(entry => {
            if (keys.includes(entry[0])) {
              objKey = `${objKey}${entry[1]}`
            }
          })
          return {
            ...obj,
            [objKey]: item,
          }
        }, init)
      },
      pay(rowid_docto = null) {
        let receiptsToPay = this.paymentSummary;
        let total = this.totalPayment
        if (rowid_docto) {
          receiptsToPay = this.pensions.filter(pension => pension.rowid_docto == rowid_docto)
          total = receiptsToPay[0].total
          if (receiptsToPay[0].dias_vencida > 0){
            this.overdue_bills = 1
          }
        } else {
          this.overdue_bills = this.paymentSummary.filter(x => x.dias_vencida > 0 ).length
        }
        
        if (this.overdue_bills > 0 && !this.overdue_is_accepted){
          this.overdue_payment_dialog = true;
          this.overdue_rowid_docto = rowid_docto;
          return true;
        }

        axios.post('/api/pension/pay', { receiptsToPay, total: parseInt(total) })
          .then(resp => {
            if (resp.status === 200) {
              if (resp.data.error) {
                this.$store.dispatch('responseMessage', {
                  type: 'error',
                  text: resp.data.message,
                  title: this.$t('error_alert_text'),
                  modal: true
                })
                this.loading_button = 0;
                return;
              }
              this.payment_dialog = true;
              setTimeout(() => {
                window.location = resp.data.url;
              }, 5000);
            } else {
              this.$store.dispatch('responseMessage', {
                type: 'error',
                text: this.$t('extracurriculares.pay_reserve.payment_error'),
                title: this.$t('error_alert_text'),
                modal: true
              })
            }
            this.loading_button = 0;
          })
          .catch(err => {
            this.loading_button = 0
            console.log(err)
          })

      },
      isPending(rowid_docto) {
        if (this.pendingPlatform[rowid_docto]) {
          if (this.pendingPlatform[rowid_docto].status === 0) {
            return true
          }
        }
        return false
      },
      isFailed(rowid_docto) {
        if (this.pendingPlatform[rowid_docto]) {
          if (this.pendingPlatform[rowid_docto].status === -1) {
            return true
          }
        }
        return false
      },
      isApproved(rowid_docto) {
        if (this.pendingPlatform[rowid_docto]) {
          if (this.pendingPlatform[rowid_docto].status === 1) {
            return true
          }
        }
        return false
      },
      validatePayment(pension) {
        this.loading_val_button = pension.rowid_docto
        axios.post('/api/pension/payment/validate', { payment_id: pension.payment_id })
          .then(resp => {
            if (resp.status === 200) {
              this.getPending();
              this.loading_val_button = 0;
            }
          })
          .catch(err => {
            this.loading_val_button = 0
            console.log(err)
          })
      },
      paymentProof(rowid_docto, note) {
        let payment_to_show = {}
        if (this.pendingPlatform[rowid_docto]) {
          payment_to_show = this.pendingPlatform[rowid_docto].payment
        } else {
          return false
        }
        this.payment_detail_dialog = true

        this.payment_to_show = payment_to_show
        this.payment_detail = note

      },
      filerPensions() {
        this.$validator.validateAll().then(valid => {
          if(valid) {
            if (this.form.start_date > this.form.end_date) {
              this.form.errors.set({
                start_date: "La fecha inicial no puede ser mayor que la final"
              })

              return
            }
            this.loading_query_button = true
            axios.post('/api/pension/filter', this.form)
              .then(resp => {
                if (resp.status === 200) {
                  this.loading_query_button = false
                  this.filteredPensions = resp.data
                }
              }).catch(err => {
                this.loading_query_button = false
                console.log(err)
              })
          }
        })
      },
      validatePaymentParam() {
        if (this.$route.query.idPago) {
          let paymentToValidate
          Object.keys(this.pendingPlatform).forEach(pending => {
            if (this.pendingPlatform[pending].payment) {
              if (this.pendingPlatform[pending].payment.payment_state === 'PENDING') {
                if (this.pendingPlatform[pending].payment.payment_id == this.$route.query.idPago) {
                  this.validatePayment(this.pendingPlatform[pending])
                }
              }
            }
          })
        }
      },
      downloadPaymentProof(rowid_docto) {

        axios({
            url: `/user/payment/proof/${rowid_docto}/PENSIONS`,
            method: 'GET',
            responseType: 'blob'
          })
          .then(resp => {
            if (resp.status === 200) {

              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(new Blob([resp.data]));
              link.setAttribute('download', `comprobante.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.loading = 0;
            }
          })
          .catch(error => {
            this.loading = 0;
            if (error.response.status === 404) {
              this.$store.dispatch('responseMessage', {
                  type: 'info',
                  text: 'Este servicio se ha pagado correctamente, pero el pago no ha sido generado en el sistema contable o bien la relación de este pago no existe en nuestro sistema. Por favor contacte el área de soporte',
                  title: 'Información',
                  modal: true
                })
            }
            console.log(error)
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/pension/show.vue